import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { Entity } from '../../models/common';
import {
    listDevBoxAddOns,
    listDevBoxAddOnsError,
    listDevBoxAddOnsFailed,
    listDevBoxAddOnsSuccess,
} from '../actions/add-ons/add-ons-action-creators';
import { devBoxAddOnsAdapter } from '../adapters/dev-box-add-ons-adapters';
import { AddOnsStatusStore, AddOnsStore, DevBoxAddOnsDataStore } from '../store/add-ons-store';
import { getPayload } from '../utilities/payload-action';
import { createIndexedStatusReducer } from './indexed-status-reducer';

export const addOnsReducer = combineReducers<AddOnsStore>({
    data: createReducer(DevBoxAddOnsDataStore(), (builder) => {
        builder.addCase(listDevBoxAddOnsSuccess, (store, action) => {
            const { result: addOns, id } = getPayload(action);
            devBoxAddOnsAdapter.setOne(store.devBoxAddOns, Entity(id, addOns));
        });
    }),
    status: combineReducers<AddOnsStatusStore>({
        listDevBoxAddOns: createIndexedStatusReducer({
            inProgress: listDevBoxAddOns,
            error: listDevBoxAddOnsError,
            failed: listDevBoxAddOnsFailed,
            success: listDevBoxAddOnsSuccess,
        }),
    }),
});
